/** @prettier */

/**
 * SL通信一覧（空調機の台数）
 */

import {Card, CardContent, Stack, Box} from '@mui/material';
import {useLocation, Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

//MTH component import
import CardContents from '../../component/CardContents';
//interface import
import * as apiIF from '../../Type/api';
//Style import
import '../../css/common/common.css';

const SLSetting = (props: {
  gwInfo: apiIF.resParameters.gatewayInformations;
}) => {
  //URL取得
  const location = useLocation();

  const trans = useTranslation().t; //翻訳関数

  //台数をカウント
  let sl1OUNum = '0'; //SL1室外機台数
  let sl2OUNum = '0'; //SL2室外機台数
  let sl1IUNum = '0'; //SL1室内機台数
  let sl2IUNum = '0'; //SL2室内機台数
  if (props.gwInfo['register-number'] !== undefined) {
    sl1OUNum = props.gwInfo['register-number']['sl-system-1']['outdoor-unit'];
    sl2OUNum = props.gwInfo['register-number']['sl-system-2']['outdoor-unit'];
    sl1IUNum = props.gwInfo['register-number']['sl-system-1']['indoor-unit'];
    sl2IUNum = props.gwInfo['register-number']['sl-system-2']['indoor-unit'];
  }

  return (
    <>
      {/* １系統 */}
      <Card className="gwSetting__contents--communication">
        <CardContent>
          <Stack spacing={4}>
            <Box className="gwSetting__contents__title">
              <Link
                to={`${location.pathname}/sl1/sl-ou-registration${location.search}`}
                id="mv-linkSlSetting1">
                {trans('SLSetting.linkTxt.superlink1')}
              </Link>
            </Box>
            {/* 台数 */}
            <Stack spacing={2} className="gwSetting__contents__contents">
              {/* 室内機数 */}
              <CardContents
                class="gwSetting__contents__contents__underLine"
                valueDescription={trans('SLSetting.item.title.indoorUnit')}
                value={`${sl1IUNum} ${trans('SLSetting.item.value.unit')}`}
              />
              {/* 室外機数 */}
              <CardContents
                class="gwSetting__contents__contents__underLine"
                valueDescription={trans('SLSetting.item.title.outdoorUnit')}
                value={`${sl1OUNum} ${trans('SLSetting.item.value.unit')}`}
              />
            </Stack>
          </Stack>
        </CardContent>
      </Card>
      {/* ２系統 */}
      <Card className="gwSetting__contents--communication">
        <CardContent>
          <Stack spacing={4}>
            <Box className="gwSetting__contents__title">
              <Link
                to={`${location.pathname}/sl2/sl-ou-registration${location.search}`}
                id="mv-linkSlSetting2">
                {trans('SLSetting.linkTxt.superlink2')}
              </Link>
            </Box>
            {/* 台数 */}
            <Stack spacing={2} className="gwSetting__contents__contents">
              {/* 室内機数 */}
              <CardContents
                class="gwSetting__contents__contents__underLine"
                valueDescription={trans('SLSetting.item.title.indoorUnit')}
                value={`${sl2IUNum} ${trans('SLSetting.item.value.unit')}`}
              />
              {/* 室外機数 */}
              <CardContents
                class="gwSetting__contents__contents__underLine"
                valueDescription={trans('SLSetting.item.title.outdoorUnit')}
                value={`${sl2OUNum} ${trans('SLSetting.item.value.unit')}`}
              />
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </>
  );
};
export default SLSetting;
